import { call, put, takeLatest } from "redux-saga/effects";
import { TOKEN_KEY } from "Communication/Constants";
import RecoverPasswordRequest from "Communication/ApiClasses/RecoverPasswordRequest";
import * as actionTypes from "Redux/Actions/actionTypes";
import {
  doLoadingStart,
  doLoadingFinish,
} from "Components/Common/ProgressIndicator/Actions/ProgressIndicatorActions";
import STRINGS from "Constants/Strings";

// worker
function* handleRecoverPassword(action) {
  yield put(doLoadingStart(STRINGS.FORGOTPASSWORD.API_KEYS.RECOVER_PASSWORD));
  const recoverPasswordApi = new RecoverPasswordRequest(action.data);
  try {
    const result = yield call(recoverPasswordApi.getData);
    sessionStorage.setItem(TOKEN_KEY, result.data.token);
    yield put({
      type: actionTypes.RECOVER_PASSWORD_RESPONSE,
      success: result,
    });
  } catch (error) {
    yield put({
      type: actionTypes.RECOVER_PASSWORD_ERROR,
      error: error.response.data.description,
    });
  } finally {
    yield put(
      doLoadingFinish(STRINGS.FORGOTPASSWORD.API_KEYS.RECOVER_PASSWORD)
    );
  }
}

// watcher
export default function* recoverPasswordWatcherSaga() {
  yield takeLatest(actionTypes.RECOVER_PASSWORD_REQUEST, handleRecoverPassword);
}
